import "../../../styles/pagelayout.scss";
import "./SettingFileLIst.scss";
import Auth from "@aws-amplify/auth";
import Cookies from "js-cookie";
import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { GetUserProfile } from "../../../API/endpoints/User";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/header/NavBar";
import BreadCrumb from "../../components/header/BreadCrumb";
import PrimaryMessage from "../../components/Alerts/PrimaryMessage";
import Folder from "../components/folder/Folder";
import { GetFilesSettingsForRole } from "../../../API/endpoints/fileupload/FileSettings";
import {
  DeleteBrandDocument,
  GetBrand,
  GetBrandDocs,
  GetRequestedInfo,
  requestBrandInformation,
} from "../../../API/endpoints/Brands";
import AddIcon from "@mui/icons-material/Add";
import {
  GetPermissionsByRoleAndModuleID,
  GetRoleById,
} from "../../../API/endpoints/RolesAndPermissions/Roles";
import TableMUI from "../../components/TableMUI/TableMUI";
import { brandFilesTableColumns } from "../../components/TableMUI/TableColumns";
import BrandFilesDropDown from "./BrandFilesDropDown";
import {
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import { useForm } from "react-hook-form";
import ToastMessage from "../../components/toasts/ToastMessage";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import AdvisoryReportUploadModal from "../../components/modalForms/AdvisoryManagement/AdvisoryReportUpload";
import AddBrandDocumentModal from "../../components/modalForms/BrandManagement/AddBrandDocumentModal";

const SettingFileLIst = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [userID, setUserID] = useState<string | undefined>("");
  const [userProfile, setUserProfile] = useState<any>({});
  // const [showAlert, setAlert] = useState(true);
  const [files, setFiles] = useState<any[]>([]);
  const [brandName, setBrandName] = useState("");
  const [roleID, setRoleID] = useState<number>(0);
  const [permissions, setPermissions] = useState<any[]>([]);
  const [listPage, setListPage] = useState(0);
  const [dataCount, setDataCount] = useState(0);
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [inforReqList, setInforReqList] = useState<any[]>([]);
  const [notification, setNotification] = useState({ type: "", msg: "" });
  const [documentID, setDocumentID] = useState<any>("");
  const [showDeleteDocument, setShowDeleteDocument] = useState(false);
  const [reload, setReload] = useState(false);
  const [showAddBrandDocumentModal, setShowAddBrandDocumentModal] =
    useState(false);
  const [data, setData] = useState<
    {
      id: string;
      file_name: string;
      description: string;
      path: string;
    }[]
  >([]);

  useEffect(() => {
    setUserID(Cookies.get("userID"));
  }, []);

  useEffect(() => {
    if (userID) {
      (async () => {
        const response = await GetUserProfile(userID);
        if (response?.data) {
          setRoleID(response.data?.user_roles[0]?.roles.id);
          setUserProfile(response?.data);
        }
      })();
    }
  }, [userID, navigate]);

  // useEffect(() => {
  //   (async () => {
  //     const res = await GetBrandDocs(params.brandid, listPage + 1);
  //     setDataCount(res.data.count);
  //     setData(res.data);
  //   })();
  // }, [listPage, userID, params.brandid, reload]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [brandDocsRes, requestedInfoRes] = await Promise.all([
          GetBrandDocs(params.brandid, listPage + 1),
          GetRequestedInfo(params?.brandid),
        ]);

        setDataCount(brandDocsRes.data.count);

        const combinedData = [...brandDocsRes.data, ...requestedInfoRes.data];

        setData(combinedData);
      } catch (error) {
        console.error("Error fetching combined data:", error);
      }
    };

    fetchData();
  }, [listPage, userID, params.brandid, reload]);

  /* useEffect(() => {
    if (roleID) {
      (async () => {
        const roleDetails = await GetRoleById(roleID.toString());

        if (roleDetails?.data?.type === "organization") {
          const response = await GetPermissionsByRoleAndModuleID(
            roleID.toString(),
            "8"
          );
          console.log(response);
          setPermissions(response?.data);
        } else if (roleDetails?.data?.type === "administrative") {
          const response = await GetPermissionsByRoleAndModuleID(
            roleID.toString(),
            "2"
          );
          console.log(response);
          setPermissions(response?.data);
        }
      })();
    }
  }, [roleID]); */

  useEffect(() => {
    (async () => {
      // try {
      //   const response = await GetFilesByCategory("brand");
      //   setFiles(response?.data);
      // } catch (error) {}
      try {
        const res = await GetBrand(params.brandid);
        setBrandName(res?.data?.brand_name);
      } catch (error) {}
    })();
  }, [params.brandid]);

  /* useEffect(() => {
    // if (
    //   permissions[0]?.sub_modules[5]?.permissions_actions[1]?.permission[0]
    //     ?.permission === true
    // ) {
    //   try {
    //     const response = await GetFilesByCategory("brand");
    //     setFiles(response?.data);
    //   } catch (error) {}
    // }
    (async () => {
      if (
        permissions[0]?.sub_modules[5]?.permissions_actions[1]?.permission[0]
          ?.permission === true
      ) {
        try {
          const response = await GetFilesSettingsForRole(roleID.toString());
          const fileSettingsList = response?.data
            .map((item: any) => {
              return item.file_settings;
            })
            .filter((item: any) => {
              return item.category_id === 1;
            });
          console.log(fileSettingsList);
          setFiles(fileSettingsList);
          // const res = await GetFilesByCategory("brand");
          // console.log(res);
          // const publicFiles = res?.data.filter((item: any) => {
          //   return item.public_access === true;
          // });
          // setFiles((prev: any) => [...prev, ...publicFiles]);
        } catch (error) {}
      }
    })();
  }, [roleID, permissions]); */

  const handleCloseDeleteDocument = () => {
    setShowDeleteDocument(false);
    setDocumentID("");
  };

  const downloadFile = (path: string) => {
    window.open(path, "_blank");
  };

  const handleDeleteDoc = async () => {
    try {
      await DeleteBrandDocument(documentID);
      handleCloseDeleteDocument();
      setNotification({
        type: "success",
        msg: "Document Deleted successfully",
      });
      setReload((current) => !current);
    } catch (err) {
      console.log("err", err);
      handleCloseDeleteDocument();
      setNotification({
        type: "",
        msg: "",
      });
    }
  };

  const handleCloseAddBrandDocumentModal = () => {
    setShowAddBrandDocumentModal(false);
  };

  const handleCloseNotification = () => {
    setNotification({
      type: "",
      msg: "",
    });
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      file_name: "",
      description: "",
    },
  });

  const handleCloseInfoModal = () => {
    setOpenInfoModal(false);
    setInforReqList([]);
  };

  const onSubmitInfoReq = (data: any) => {
    setInforReqList([...inforReqList, data]);
    reset();
  };

  const handleRemoveReqInfoItem = (index: any) => {
    const data = [...inforReqList];
    data.splice(index, 1);
    setInforReqList([...data]);
  };

  const handleSaveInfoReq = () => {
    if (inforReqList.length) {
      inforReqList.forEach(async (item: any) => {
        const req = { ...item, brand_id: params.brandid };
        await requestBrandInformation(req);
      });
      setReload(!reload);
      setNotification({
        type: "success",
        msg: "Information requested successfully",
      });
      handleCloseInfoModal();
    } else {
      setNotification({
        type: "error",
        msg: "Add at least one information request",
      });
    }
  };

  const breadcrumbData = [
    {
      name: "brand management",
      url: "/BrandManagement",
      active: false,
    },
    {
      name: "brands",
      url: "/BrandManagement",
      active: false,
    },
    {
      name: brandName,
      url: `/brand/${params.brandid}`,
      active: false,
    },
    {
      name: "Files",
      url: `/brand-filesettings/${params.brandid}`,
      active: true,
    },
  ];

  const columns = brandFilesTableColumns(
    setDocumentID,
    setShowDeleteDocument,
    downloadFile
  );

  return (
    <Container fluid className="pge-layout SettingFileLIst">
      <Row>
        <Col className="sidebar">
          <Sidebar active="brand" />
        </Col>
        <Col className="content-section">
          <Navbar userProfile={userProfile} />
          <BreadCrumb breadcrumbData={breadcrumbData} />
          {/* {showAlert && (
            <div className="alert-wraper">
              <PrimaryMessage
                isAlertOpen={showAlert}
                // type="primary"
                headingText="Info"
                bodyText="This section works like a File manager.
                                Upload/drag and drop your product files
                                to each of the specified folders to access
                                and manage all your product files in one
                                place"
                dismissible={true}
                onCancel={handleCloseAlert}
              />
            </div>
          )} */}
          {/* <div className="folder-wraper">
            {files.map((item: any) => {
              return (
                <div key={item.id}>
                  <Folder
                    url={`/brand-files/${params.brandid}&&${item.id}`}
                    fileName={item.name}
                  />
                </div>
              );
            })}
          </div> */}
          <div className="action-panel">
            <BrandFilesDropDown
              setOpenInfoModal={setOpenInfoModal}
              userType={userProfile?.user_type}
              setShowAddBrandDocumentModal={setShowAddBrandDocumentModal}
            />
          </div>
          <div className="table-mui">
            <div className="TableMUIcountainer">
              <TableMUI
                columns={columns}
                rows={data}
                dataCount={dataCount}
                setListPage={setListPage}
                listPage={listPage}
              />
            </div>
          </div>
        </Col>
      </Row>
      <Dialog
        className="modal_700"
        open={openInfoModal}
        onClose={handleCloseInfoModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Request For More Information"}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseInfoModal}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <GridCloseIcon />
        </IconButton>
        <DialogContent>
          <Card
            sx={{
              boxShadow: "none",
              border: "1px solid #EEEAF5",
            }}
          >
            <Row
              sx={{
                color: "#344054",
                backgroundColor: "#fcfcfd",
                align: "center",
                lineHeight: "44px",
                textIndent: "12px",
              }}
              className=" font-14 py20 px-2"
            >
              <Col sm={3} lg={3} xl={3}>
                File
              </Col>
              <Col sm={8} lg={8} xl={8}>
                Description
              </Col>
              <Col sm={1} lg={1} xl={1} className="ml-n20">
                Actions
              </Col>
            </Row>
            <Form
              onSubmit={handleSubmit((data) => {
                onSubmitInfoReq(data);
              })}
            >
              <Row className="mb16px mx-1 ">
                <Col sm={3} lg={3} xl={3} className="p-03">
                  <Form.Group className="formgroup" controlId="file_name">
                    <Form.Control
                      type="text"
                      placeholder="File Name"
                      {...register("file_name", {
                        required: "* This field is required",
                      })}
                    />
                    <Form.Text muted>
                      <span>
                        {/* {errors?.first_name && (
                              <p className="error-form">
                                {String(errors.first_name?.message)}
                              </p>
                            )} */}
                      </span>
                    </Form.Text>
                  </Form.Group>
                </Col>
                <Col sm={8} lg={8} xl={8} className="p-03">
                  <Form.Group controlId="">
                    <Form.Control
                      style={{
                        textAlign: "left",
                        color: "#475467",
                        fontSize: "12px",
                      }}
                      as="textarea"
                      rows={3}
                      placeholder="sample text"
                      {...register("description", {
                        required: "* This field is required",
                      })}
                    />
                  </Form.Group>
                </Col>
                <Col sm={1} lg={1} xl={1} className="p-03">
                  <Button
                    style={{
                      minWidth: "40px",
                      maxWidth: "40px",
                      padding: "0",
                      maxHeight: "40px",
                      textAlign: "center",
                      lineHeight: "20px",
                    }}
                    type="submit"
                    className="badgepill-blue50  blue-text br-0 bold no-border align-center"
                  >
                    <AddIcon
                      sx={{
                        fontSize: "19px",
                        fontWeight: "500",
                        alignItems: "center",
                      }}
                    />
                  </Button>
                </Col>
              </Row>
            </Form>
            {inforReqList.map((item, key) => {
              return (
                <Row className="mb16px mx-1" key={key}>
                  <Col sm={3} lg={3} xl={3}>
                    <Typography
                      sx={{
                        textAlign: "left",
                        color: "#1D2939",
                        fontSize: "14px",
                      }}
                    >
                      {item?.file_name}
                    </Typography>
                  </Col>
                  <Col sm={8} lg={8} xl={8}>
                    <Typography
                      sx={{
                        textAlign: "left",
                        color: "#475467",
                        fontSize: "12px",
                      }}
                    >
                      {item?.description}
                    </Typography>
                  </Col>
                  <Col sm={1} lg={1} xl={1}>
                    <Button
                      style={{
                        minWidth: "40px",
                        maxWidth: "40px",
                        padding: "0",
                        maxHeight: "40px",
                        textAlign: "center",
                        lineHeight: "20px",
                      }}
                      onClick={() => handleRemoveReqInfoItem(key)}
                      className="badgepill-blue50  blue-text br-0 bold no-border align-center"
                    >
                      <img
                        width="20px"
                        className="listicon"
                        src="../svgs/delete.svg"
                        alt="Singapore"
                      />
                    </Button>
                  </Col>
                </Row>
              );
            })}
          </Card>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleCloseInfoModal}>
            Cancel
          </Button>
          <Button
            // sx={{ background: "#0152FB", color: "#FFFFFF" }}
            onClick={handleSaveInfoReq}
            autoFocus
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <ConfirmModal
        haveIcon={false}
        isModalOpen={showDeleteDocument}
        submit={handleDeleteDoc}
        closeModal={handleCloseDeleteDocument}
        submitBtnText="Delete"
        cancelBtnText="Cancel"
        title="Confirm Document Deletion"
        bodyText="Are you sure you want to delete this document?"
      />
      <ToastMessage
        notification={notification}
        onCancel={handleCloseNotification}
      />
      <AddBrandDocumentModal
        isModalOpen={showAddBrandDocumentModal}
        onCancel={handleCloseAddBrandDocumentModal}
        brand_id={params.brandid || ""}
        setNotification={setNotification}
        setReload={setReload}
      />
    </Container>
  );
};

export default SettingFileLIst;
